import type { CheckboxGroupItem } from "@/components/molecules/CheckboxGroup/CheckboxGroup";

/**
 * Generate a list of CheckboxGroupItem from account and profile tags.
 *
 * @param accountTags - All available tags.
 * @param profileTags - Tags that should be marked as checked.
 */
export function generateCheckboxGroupItems(accountTags: string[], profileTags: string[]): CheckboxGroupItem[] {
  return accountTags.map((tag) => ({
    id: tag,
    label: tag,
    isChecked: profileTags.includes(tag),
    isDisabled: false,
  }));
}
